var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _g5, _path0, _path1, _g6, _path10, _path11, _path12, _g7, _path13, _g8, _path14, _path15, _g9, _path16, _path17, _g0, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 90,
    viewBox: "0 0 52 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3627 21.3362C3.3627 21.3362 22.0271 20.0574 22.1542 40.1247C2.08605 39.9974 3.3627 21.3362 3.3627 21.3362Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8395_62482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 19,
    width: 22,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20898 19.7192H23.652V41.3895H2.20898V19.7192Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8395_62482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2444 41.2248L22.1468 41.219C15.6741 41.1756 10.6397 39.269 7.18235 35.5425C1.76961 29.7127 2.25774 21.6117 2.28085 21.2703L2.34439 20.33L3.28887 20.2634C3.28887 20.2634 3.5546 20.2432 4.02251 20.2432C7.21123 20.2432 23.1173 21.2037 23.2386 40.1254L23.2444 41.2248Z",
    fill: "url(#paint0_linear_8395_62482)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8395_62482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 0,
    width: 17,
    height: 31
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7358 0H33.2635V30.0866H17.7358V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8395_62482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5909 29.7066L24.8197 28.9255C20.2705 24.3195 18.061 19.4097 18.2516 14.3321C18.5491 6.38149 24.6204 1.00009 24.8803 0.777316L25.5909 0.155273L26.3043 0.777316C26.5642 1.00009 32.6355 6.38149 32.933 14.3321C33.1236 19.4097 30.9141 24.3195 26.3649 28.9255L25.5909 29.7066Z",
    fill: "url(#paint1_linear_8395_62482)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3489 21.3362C48.3489 21.3362 29.6873 20.0574 29.5574 40.1247C49.6284 39.9974 48.3489 21.3362 48.3489 21.3362Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8395_62482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 19,
    width: 22,
    height: 23
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0879 19.7192H49.5309V41.3895H28.0879V19.7192Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8395_62482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4661 41.2248L28.4747 40.1254C28.596 21.2037 44.5021 20.2432 47.6879 20.2432C48.1587 20.2432 48.4245 20.2634 48.4245 20.2634L49.3661 20.33L49.4325 21.2703C49.4556 21.6117 49.9437 29.7098 44.531 35.5425C41.0765 39.269 36.0393 41.1756 29.5636 41.219L28.4661 41.2248Z",
    fill: "url(#paint2_linear_8395_62482)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_8395_62482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 32,
    width: 52,
    height: 59
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.725098 32.0381H51.0053V90.0009H0.725098V32.0381Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_8395_62482)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_8395_62482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 32,
    width: 50,
    height: 59
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8866 90.0047V32.0882C34.7162 32.0767 34.5486 32.0767 34.3782 32.0767H17.3717V90.0047H34.8866ZM13.0132 90.0047H17.3717V32.0882H17.2764C10.2289 32.0882 4.04204 37.8486 3.53369 44.8821L1.15082 77.2254C0.628027 84.2443 5.96856 90.0047 13.0132 90.0047ZM38.6385 90.0047C45.6861 90.0047 51.0237 84.2443 50.5038 77.2109L48.118 44.8705C47.6097 38.0078 41.7031 32.3573 34.875 32.0882V90.0047H38.6385Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_8395_62482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.54 90.0058H1.14941V32.043H50.54V90.0058Z",
    fill: "#FFDE59"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_8395_62482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 30,
    width: 23,
    height: 24
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30.5732H22.5117V53.123H0V30.5732Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_8395_62482)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_8395_62482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 30,
    width: 23,
    height: 24
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2558 30.5781C5.04015 30.5781 0 35.6239 0 41.853C0 48.0792 5.04015 53.1279 11.2558 53.1279C17.4715 53.1279 22.5117 48.0792 22.5117 41.853C22.5117 35.6239 17.4715 30.5781 11.2558 30.5781Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_8395_62482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 30.5781H22.5117V53.1279H0V30.5781Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_8395_62482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 34,
    width: 15,
    height: 15
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24609 34.8022H18.2834V48.8662H4.24609V34.8022Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_8395_62482)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_8395_62482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 34,
    width: 15,
    height: 15
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2672 34.8022C7.39104 34.8022 4.24854 37.9501 4.24854 41.8357C4.24854 45.7184 7.39104 48.8662 11.2672 48.8662C15.1433 48.8662 18.2858 45.7184 18.2858 41.8357C18.2858 37.9501 15.1433 34.8022 11.2672 34.8022Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_8395_62482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.24854 34.8022H18.2858V48.8662H4.24854V34.8022Z",
    fill: "#3D1F1E"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68588 43.04C8.68588 41.3477 9.9454 40.1278 11.5981 40.1278C10.0222 40.1278 8.68722 38.8283 8.68722 37.2142C8.68722 38.8129 7.44135 40.1278 5.77368 40.1278C7.44135 40.1278 8.68588 41.4091 8.68588 43.04Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68588 37.2129L8.68722 37.2142M8.68722 37.2142C8.68722 38.8283 10.0222 40.1278 11.5981 40.1278C9.9454 40.1278 8.68588 41.3477 8.68588 43.04C8.68588 41.4091 7.44135 40.1278 5.77368 40.1278C7.44135 40.1278 8.68722 38.8129 8.68722 37.2142Z",
    stroke: "white",
    strokeWidth: 1.24156,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_8395_62482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 66,
    width: 14,
    height: 7
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2053 66.1226H32.6399V72.1619H19.2053V66.1226Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_8395_62482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9229 73.7437C25.4819 73.7437 25.0458 73.7196 24.6145 73.6703C24.1808 73.6221 23.7618 73.5497 23.3549 73.4542C22.948 73.3577 22.5606 73.2409 22.1951 73.1019C21.8272 72.963 21.4885 72.8047 21.1767 72.6281C20.8648 72.4505 20.5871 72.2585 20.3434 72.05C20.0973 71.8425 19.8902 71.6225 19.7221 71.3909C19.554 71.1602 19.4273 70.9218 19.3396 70.6767C19.2543 70.4306 19.2129 70.1836 19.2129 69.9326C19.2129 69.6827 19.2543 69.4347 19.3396 69.1895C19.4273 68.9444 19.554 68.706 19.7221 68.4744C19.8902 68.2438 20.0973 68.0237 20.3434 67.8163C20.5871 67.6078 20.8648 67.4157 21.1767 67.2382C21.4885 67.0616 21.8272 66.9033 22.1951 66.7643C22.5606 66.6254 22.948 66.5086 23.3549 66.4121C23.7618 66.3165 24.1808 66.2442 24.6145 66.1959C25.0458 66.1467 25.4819 66.1226 25.9229 66.1226C26.3639 66.1226 26.8 66.1467 27.2313 66.1959C27.665 66.2442 28.084 66.3165 28.4909 66.4121C28.8978 66.5086 29.2852 66.6254 29.6507 66.7643C30.0186 66.9033 30.3572 67.0616 30.6691 67.2382C30.981 67.4157 31.2587 67.6078 31.5024 67.8163C31.7485 68.0237 31.9556 68.2438 32.1237 68.4744C32.2918 68.706 32.4185 68.9444 32.5062 69.1895C32.5915 69.4347 32.6329 69.6827 32.6329 69.9326C32.6329 70.1836 32.5915 70.4306 32.5062 70.6767C32.4185 70.9218 32.2918 71.1602 32.1237 71.3909C31.9556 71.6225 31.7485 71.8425 31.5024 72.05C31.2587 72.2585 30.981 72.4505 30.6691 72.6281C30.3572 72.8047 30.0186 72.963 29.6507 73.1019C29.2852 73.2409 28.8978 73.3577 28.4909 73.4542C28.084 73.5497 27.665 73.6221 27.2313 73.6703C26.8 73.7196 26.3639 73.7437 25.9229 73.7437Z",
    fill: "#3D1F1E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_8395_62482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 71,
    width: 12,
    height: 2
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.573 71.4819H31.2737V72.8379H20.573V71.4819Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_8395_62482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2737 72.1597C31.2737 72.204 31.2378 72.2479 31.1704 72.2919C31.1009 72.3354 30.9999 72.3777 30.8652 72.4189C30.7306 72.46 30.5667 72.4988 30.3715 72.536C30.1762 72.5728 29.9541 72.6072 29.7049 72.6385C29.4581 72.6701 29.1865 72.6982 28.8948 72.7227C28.603 72.7477 28.2955 72.7682 27.9701 72.7853C27.6447 72.8023 27.3103 72.8153 26.9669 72.824C26.6213 72.8327 26.2734 72.8371 25.9233 72.8371C25.571 72.8371 25.2231 72.8327 24.8798 72.824C24.5341 72.8153 24.1997 72.8023 23.8743 72.7853C23.5511 72.7682 23.2414 72.7477 22.9497 72.7227C22.6579 72.6982 22.3864 72.6701 22.1395 72.6385C21.8904 72.6072 21.6682 72.5728 21.473 72.536C21.2777 72.4988 21.1139 72.46 20.9792 72.4189C20.8446 72.3777 20.7436 72.3354 20.674 72.2919C20.6067 72.2479 20.573 72.204 20.573 72.1597C20.573 72.115 20.6067 72.0711 20.674 72.0272C20.7436 71.9836 20.8446 71.9413 20.9792 71.9002C21.1139 71.859 21.2777 71.8202 21.473 71.783C21.6682 71.7462 21.8904 71.7118 22.1395 71.6806C22.3864 71.6489 22.6579 71.6208 22.9497 71.5963C23.2414 71.5714 23.5511 71.5508 23.8743 71.5338C24.1997 71.5168 24.5341 71.5037 24.8798 71.495C25.2231 71.4863 25.571 71.4819 25.9233 71.4819C26.2734 71.4819 26.6213 71.4863 26.9669 71.495C27.3103 71.5037 27.6447 71.5168 27.9701 71.5338C28.2955 71.5508 28.603 71.5714 28.8948 71.5963C29.1865 71.6208 29.4581 71.6489 29.7049 71.6806C29.9541 71.7118 30.1762 71.7462 30.3715 71.783C30.5667 71.8202 30.7306 71.859 30.8652 71.9002C30.9999 71.9413 31.1009 71.9836 31.1704 72.0272C31.2378 72.0711 31.2737 72.115 31.2737 72.1597Z",
    fill: "#FA5B5B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_8395_62482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 30,
    width: 23,
    height: 24
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1548 30.5732H51.6665V53.123H29.1548V30.5732Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_8395_62482)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_8395_62482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 30,
    width: 23,
    height: 24
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4131 30.5781C34.1945 30.5781 29.1572 35.6239 29.1572 41.853C29.1572 48.0792 34.1945 53.1279 40.4131 53.1279C46.6288 53.1279 51.6689 48.0792 51.6689 41.853C51.6689 35.6239 46.6288 30.5781 40.4131 30.5781Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_8395_62482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1572 30.5781H51.6689V53.1279H29.1572V30.5781Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_8395_62482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 34,
    width: 15,
    height: 15
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3813 34.8022H47.4215V48.8662H33.3813V34.8022Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_8395_62482)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_8395_62482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 34,
    width: 15,
    height: 15
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4029 34.8022C36.5239 34.8022 33.3813 37.9501 33.3813 41.8357C33.3813 45.7184 36.5239 48.8662 40.4029 48.8662C44.279 48.8662 47.4215 45.7184 47.4215 41.8357C47.4215 37.9501 44.279 34.8022 40.4029 34.8022Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_8395_62482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3813 34.8022H47.4215V48.8662H33.3813V34.8022Z",
    fill: "#3D1F1E"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2674 42.8412C38.2674 41.149 39.5269 39.929 41.1796 39.929C39.6037 39.929 38.2688 38.6296 38.2688 37.0155C38.2688 38.6142 37.0229 39.929 35.3552 39.929C37.0229 39.929 38.2674 41.2104 38.2674 42.8412Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2674 37.0142L38.2688 37.0155M38.2688 37.0155C38.2688 38.6296 39.6037 39.929 41.1796 39.929C39.5269 39.929 38.2674 41.149 38.2674 42.8412C38.2674 41.2104 37.0229 39.929 35.3552 39.929C37.0229 39.929 38.2688 38.6142 38.2688 37.0155Z",
    stroke: "white",
    strokeWidth: 1.24156,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8395_62482",
    x1: 12.7522,
    y1: 20.2432,
    x2: 12.7522,
    y2: 41.2248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8395_62482",
    x1: 25.5923,
    y1: 0.155273,
    x2: 25.5923,
    y2: 29.7066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8395_62482",
    x1: 38.9597,
    y1: 20.2432,
    x2: 38.9597,
    y2: 41.2248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInscription);
export default __webpack_public_path__ + "static/media/inscription.49fc9757e5110effd8392796b7d3d0b7.svg";
export { ForwardRef as ReactComponent };